<script>
	import UIIcon from "./UIIcon.svelte";
	import router from "../stores/router";

	export let data = {};

	let icon = "";
	let url = "";
	$: {
		icon = data.target === "url" ? "right" : "file";
		url = data.target === "url" ? data.url : data.file;
	}
</script>

<nav class="UILink _{data.style}">
	<a
		href={url}
		on:click|preventDefault={() => url && router.push(url)}
		class:_disabled={!url}
	>
		<div class="UILink-layout _{data.style}">
			{#if data.style === "text"}
				<UIIcon type={icon} color="#999" size={28} />
			{/if}
			<span>{data.label}</span>
			{#if data.style === "button"}
				<UIIcon
					type={icon}
					color={url ? "#bb5858" : "#eeeeee"}
					size={20}
				/>
			{/if}
		</div>
	</a>
</nav>

<style global>
	.UILink {
		padding: 1em 0;
	}

	.UILink._button {
		text-align: center;
	}
	.UILink._button > a {
		min-width: 280px;
		max-width: 100%;
		position: relative;
		display: inline-block;
	}

	.UILink._button > a {
		background: #fff;
		box-shadow: 0 2px 0 rgba(187, 88, 88, 0.1);
		color: #bb5858;
		border: 1px solid #bb5858;
		border-radius: 10em;
		transition: background 100ms linear;
	}
	.UILink._button > a:hover {
		background: #bb5858;
		color: #fff;
	}
	.UILink._button > a._disabled {
		border: 1px solid #999;
		background: #eeeeee;
		color: #999;
		pointer-events: none;
		box-shadow: none;
	}

	.UILink._text {
		text-align: left;
		max-width: 720px;
		margin: 0 auto;
	}
	.UILink._text + .UILink._text {
		padding-top: 0;
	}

	.UILink._text > a {
		color: inherit;
		display: inline-block;
	}

	.UILink._text > a._disabled {
		background: #ccc;
		pointer-events: none;
		box-shadow: none;
	}

	.UILink-layout {
		display: flex;
		align-items: center;
	}
	.UILink-layout._button {
		padding: 1em;
		width: 100%;
	}

	.UILink-layout._button > span {
		flex: 1 1 auto;
		margin-left: 1em;
		border-bottom: 1px dashed transparent;
	}

	.UILink._button > a:focus-visible .UILink-layout._button > span {
		border-color: #d77;
	}

	.UILink-layout._text > span {
		padding-left: 0.5em;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		transition: border 100ms linear;
	}
	.UILink._text > a:hover .UILink-layout._text > span {
		border-color: rgba(0, 0, 0, 0.5);
	}
	.UILink._text > a:focus-visible .UILink-layout._text > span {
		border-bottom: 1px dashed #d77;
	}

	.UILink-layout > :global(svg) {
		flex: 0 0 28px;
	}
	.UILink-layout._button > :global(svg) {
		flex: 0 0 20px;
	}

	.UILink._button > a:hover .UILink-layout._button > :global(svg) {
		stroke: #fff !important;
	}
</style>
